import React from 'react';
import { Autocomplete, TextField, FormHelperText, Box } from '@mui/material';

function SearchableDropdown({ label, onChange, options, sx, error, helperText, disabled, ...props }) {
  return (
    <Box sx={{ ...sx, position: 'relative' }}>
      <Autocomplete
        options={options}
        getOptionLabel={(option) => option.label}
        value={options.find((option) => option.value === props.value) || null}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            fullWidth
            required
            error={error}
            disabled={disabled}
            {...props}
          />
        )}
        fullWidth
        required
        disabled={disabled}
      />
      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </Box>
  );
}

export default SearchableDropdown;
